import React, { FunctionComponent, useEffect } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { EventSection } from 'src/components/calendar/eventSection'
import { LoadingContent } from 'src/components/loading-content/LoadingContent'
import { LoadingPlaceholder } from 'src/components/loading-content/LoadingPlaceholder'
import { DATE_AND_TIME_ID, DATE_DISPLAY_OPTIONS } from './constants'
import locale from './locale'

const style = require('./SingleCalendarWidget.css')

interface Props {
  eventData: any,
  loading: Boolean,
}

declare var $u
declare var BASE_URL: string
const SCRIPT_ID = 'calendar-widget-script'

const loadCalendarWidget = (eventId, lang) => {
  if (window.document.body.querySelector(`#${SCRIPT_ID}`)) return

  const loadScript = document.createElement('script')
  loadScript.src = `${BASE_URL}/embed2.js`
  loadScript.id = SCRIPT_ID
  loadScript.setAttribute('data-widget-type', 'universe-calendar')
  loadScript.setAttribute('data-target-type', 'time-slots')
  loadScript.setAttribute('data-target-id', eventId)
  loadScript.setAttribute('data-state', `lang=${lang}`)

  if (window.document.querySelector(`.${style.calendar}`)) {
    window.document.querySelector(`.${style.calendar}`).appendChild(loadScript)
  } else {
    window.document.querySelector(`.${style.calendarWithFilter}`).appendChild(loadScript)
  }
}

const Placeholder = () => (
  <LoadingPlaceholder modifierClass={style.placeholder}>
    <LoadingContent width="170px" height="25px" borderRadius="rounder" />
    <LoadingContent width="138px" height="62px" borderRadius="sharper" />
  </LoadingPlaceholder>
)

const SingleCalendarWidgetComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  eventData,
  loading,
  intl,
}) => {
  const { formatMessage } = intl

  if (loading) return <Placeholder />
  useEffect(() => {
    if (eventData.id) {
      loadCalendarWidget(eventData.id, intl.locale)
    }
  }, [eventData, intl.locale])

  if (eventData.hiddenDate || eventData.dateDisplayOption === DATE_DISPLAY_OPTIONS.hideEventTime) return null

  const className = eventData.showQuantityFilter ? style.calendarWithFilter : style.calendar
  return (
    <EventSection id={style.dateTime} sectionId={DATE_AND_TIME_ID} heading={formatMessage(locale.dateAndTime)}>
      <div className={className} />
    </EventSection>
  )
}

export const SingleCalendarWidget = injectIntl(SingleCalendarWidgetComponent)
